import script from "./SuccessV2.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessV2.vue?vue&type=script&setup=true&lang=js"

import "./SuccessV2.vue?vue&type=style&index=0&id=7cc87642&lang=less"

const __exports__ = script;

export default __exports__